var _defs, _use, _use2, _circle, _use3, _use4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "111.7%",
    height: "111.7%",
    x: "-5.8%",
    y: "-4.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199473505 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: "118.1%",
    height: "119.7%",
    x: "-9.1%",
    y: "-7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.204257246 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 16,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M17.922 16.383v-.002c-.11.008-.677.042-1.942.042-1.01 0-1.721-.03-1.971-.042v.003c-3.888-.171-6.79-.848-6.79-1.658 0-.809 2.902-1.486 6.79-1.66v2.644c.254.018.982.061 1.988.061 1.207 0 1.812-.05 1.925-.06v-2.643c3.88.173 6.775.85 6.775 1.658 0 .81-2.895 1.485-6.775 1.657m0-3.59v-2.366h5.414V6.819H8.595v3.608h5.414v2.365c-4.4.202-7.709 1.074-7.709 2.118 0 1.044 3.309 1.915 7.709 2.118v7.582h3.913v-7.584c4.393-.202 7.694-1.073 7.694-2.116 0-1.043-3.301-1.914-7.694-2.117"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#26A17B",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    style: {
      mixBlendMode: "soft-light"
    },
    xlinkHref: "#b"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 14.5,
    stroke: "#000",
    strokeOpacity: 0.097
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d)",
    xlinkHref: "#e"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.b8dd2f5486d3e522c5e932a250a28998.svg";
export { ForwardRef as ReactComponent };